const _tmplCache = {};

export const jsTemplate = (str, data) => {
  let err = "";
  try {
    let func = _tmplCache[str];
    if (!func) {
      let strFunc =
        "var p=[],print=function(){p.push.apply(p,arguments);};" +
        "with(obj){p.push('" +
        str
          .replace(/[\r\t\n]/g, " ")
          .replace(/'(?=[^#]*#>)/g, "\t")
          .split("'")
          .join("\\'")
          .split("\t")
          .join("'")
          .replace(/<#=(.+?)#>/g, "',$1,'")
          .split("<#")
          .join("');")
          .split("#>")
          .join("p.push('") +
        "');}return p.join('');";

      //alert(strFunc);
      func = new Function("obj", strFunc);
      _tmplCache[str] = func;
    }
    return func(data);
  } catch (e) {
    err = e.message;
  }
  return "< # ERROR: " + err.htmlEncode() + " # >";
};
